import React from 'react'
import Header from '@components/Layout/Header'
import Sidebar from '@components/Layout/Sidebar'
import Content from '@components/Layout/Content'
import LoginForm from '@components/forms/LoginForm'
import { useAuthContext } from '@src/providers/AuthProvider'
import { useIsTablet } from '@src/hooks'

const Login = () => {
  const { signIn } = useAuthContext()
  const isTablet = useIsTablet()

  const signInHandle = async (accessToken: string) => {
    await signIn(accessToken)
  }

  return (
    <>
      <Header height={335} />
      <Sidebar />

      <Content sx={{ p: 0 }}>
        <LoginForm onSignIn={signInHandle} sx={{
          left: isTablet ? 0 : 100,
          position: 'relative',
          top: isTablet ? -180 : -100,
        }} />
      </Content>
    </>
  )
}

export default Login